// export const PIXEL_RATIO = window.devicePixelRatio || 1;
export const PIXEL_RATIO = 1;
export const VIEWPORT_RATIO = 0.98;
export const PIXEL_RATIO_DEVICE = window.devicePixelRatio || 1;
export const HTTP_STATUS_CODE = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

